"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ALLOWED_DISCOUNTS = exports.ALL_RELATED_SIGN = void 0;
exports.ALL_RELATED_SIGN = '*';
exports.MAX_ALLOWED_DISCOUNTS = 1;
//# sourceMappingURL=discount.consts.js.map